import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/schedule`;

export const ROUTE: RouteDefinition = `${baseRoute}/schedule`;

export const URL = (): RouteDefinition => `${baseRoute}/schedule`;
